var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSearch = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16.604 15.868-5.173-5.173A6.47 6.47 0 0 0 13 6.472c0-3.584-2.916-6.5-6.5-6.5a6.47 6.47 0 0 0-4.598 1.903A6.46 6.46 0 0 0 0 6.472c0 3.584 2.916 6.5 6.5 6.5a6.47 6.47 0 0 0 4.224-1.569l5.173 5.173zM6.5 11.972a5.506 5.506 0 0 1-5.5-5.5 5.46 5.46 0 0 1 1.61-3.889A5.46 5.46 0 0 1 6.5.972c3.032 0 5.5 2.467 5.5 5.5s-2.468 5.5-5.5 5.5"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSearch);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/search.svg";